'use client';

import React, { useId } from 'react';
import { useIntl } from 'react-intl';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { Checkbox } from '@packages/shared/src/ui/Checkbox/Checkbox';
import { Label } from '@packages/shared/src/ui/Label/Label';
import { useInstallmentCalculatorTracking } from '../../components/Tracking/hooks/useInstallmentCalculatorTracking/useInstallmentCalculatorTracking';

export interface PaymentPauseProps {
  /**
   * is payment pause enabled or not
   */
  checked: boolean;
  /**
   * a handler function which will be executed if the user checks or unchecks the checkbox
   */
  checkHandler: (checked: boolean) => void;
}

/**
 * payment pause atom
 *
 * displayes the payment pause checkbox
 *
 * */
export const PaymentPause = ({ checked, checkHandler }: PaymentPauseProps) => {
  const { formatMessage } = useIntl();
  const {
    company: { name },
  } = useConfig();
  const checkBoxId = useId();
  const { trackPaymentPauseClick } = useInstallmentCalculatorTracking();

  return (
    <Checkbox
      id={checkBoxId}
      checked={checked}
      onChange={(event) => {
        trackPaymentPauseClick(event.target.checked);
        checkHandler(event.target.checked);
      }}
    >
      <Label htmlFor={checkBoxId}>
        {formatMessage(
          {
            id: 'ic-atom-PaymentPause-label',
            defaultMessage:
              'Ich möchte die {brand}-Zahlpause nutzen & zahle erst in 4 Monaten<hint>*</hint>',
          },
          {
            hint: (chunks: React.ReactNode) => <span>{chunks}</span>,
            brand: name,
          },
        )}
      </Label>
    </Checkbox>
  );
};
